import { Preferences } from '@capacitor/preferences'
import { uuidv7 } from './uuidv7'

/**
 * Stable per-install device ID.
 * On web: localStorage. On native (Capacitor): @capacitor/preferences (device Keychain / SharedPreferences).
 * Never changes across sessions — required for the events.device_id column to be meaningful.
 */

const KEY = 'babyos.device_id'
let cached: string | null = null

export async function stableDeviceId(): Promise<string> {
  if (cached) return cached

  const isCapacitor = typeof (globalThis as { Capacitor?: unknown }).Capacitor !== 'undefined'
  if (isCapacitor) {
    const { value } = await Preferences.get({ key: KEY })
    if (value) {
      cached = value
      return value
    }
    const id = uuidv7()
    await Preferences.set({ key: KEY, value: id })
    cached = id
    return id
  }

  const existing = window.localStorage.getItem(KEY)
  if (existing) {
    cached = existing
    return existing
  }
  const id = uuidv7()
  window.localStorage.setItem(KEY, id)
  cached = id
  return id
}
